import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import withRouter from "../../HOC/withRouter";
import Modal from "react-modal";
import { connect } from "react-redux";
import { compose } from "react-recompose";
import SwitchWorkspaceIcon from "../svgs/SwitchWorkspaceIcon";
import { loginSwitch } from "../../utils/api";
import { authActionCreators } from "../../store/auth/actions";
import StickyModal from "../../containers/Journey/StickyModal";
import { makeOppositeShade } from "../../utils/colorService";
import "./styles.scss";
import WorkspaceItem from "./WorkspaceItem";

Modal.setAppElement("#root");

const LoginSwitch = ({ loginToWorkspace, navigate, t, otherLogins, currentClient, client }) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [anchor, setAnchor] = useState();

  const toggleModal = e => {
    setModalOpened(!modalOpened);
    setAnchor(e.currentTarget);
  };

  useEffect(() => {
    const switchTo = localStorage.getItem("switchToLogin");
    if (switchTo) {
      handleSwitchWorkspace(JSON.parse(switchTo));
      localStorage.setItem("switchToLogin", null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSwitchWorkspace = client => {
    if (client) {
      loginSwitch({ client })
        .then(res => {
          loginToWorkspace({ token: res.data.token, clientId: client._id, clientName: client.name });
          navigate("/");
          setTimeout(() => window.location.reload(), 500);
        })
        .catch(err => {
          console.error(err && err.message);
        });
    }
  };

  return (
    <div className="workspaces-container">
      <span className="workspaces-icon" onClick={toggleModal}>
        <SwitchWorkspaceIcon color={makeOppositeShade(client?.bgColor)} stroke={client?.secondaryColor} />
      </span>
      <StickyModal
        separateTitle
        rightSideStick
        belowAnchor
        title={t("loginsModal.HeaderLabel")}
        anchor={anchor}
        onClose={() => setAnchor(null)}
        modalStyles={{
          maxWidth: "400px",
          width: "100%",
        }}
      >
        {otherLogins
          ?.filter(login => login.client._id !== currentClient)
          ?.map((workspace, index) => (
            <WorkspaceItem
              key={index}
              onClick={() => handleSwitchWorkspace(workspace.client)}
              client={workspace.client}
            />
          ))}
      </StickyModal>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  loginToWorkspace: ({ token, clientId, clientName }) =>
    dispatch(authActionCreators.loginSuccess({ token, clientId, clientName })),
});

const mapStateToProps = state => ({
  otherLogins: state.user.profile.otherLogins,
  currentClient: state.client?.client?._id,
  client: state.client?.client,
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(withTranslation()(LoginSwitch));
